import React from 'react';
import PropTypes from 'prop-types';

import Banner from 'shared/banner';
import ListingSelector from './listing_selector';
import ProjectSelector from './project_selector';
import PropertySelector from './property_selector';

export default function ListingSearchForm({
  confirmationMessage,
  deal,
  edgeCrm,
  listing,
  project,
  propertyIdOverride,
  onListingChange,
  onProjectChange,
  onPropertyIdOverrideChange,
}) {
  if (confirmationMessage) {
    return <Banner content={confirmationMessage} variant="warning" />;
  }

  return (
    <div className="d-flex flex-column gap-3">
      <ProjectSelector
        deal={deal}
        project={project}
        onChange={onProjectChange}
      />

      {edgeCrm && (
        <PropertySelector
          deal={deal}
          project={project}
          propertyId={propertyIdOverride}
          onSelect={onPropertyIdOverrideChange}
        />
      )}

      <ListingSelector
        deal={deal}
        listing={listing}
        project={project}
        onChange={onListingChange}
      />
    </div>
  );
}

ListingSearchForm.propTypes = {
  confirmationMessage: PropTypes.string,
  deal: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  listing: PropTypes.object,
  project: PropTypes.object,
  propertyIdOverride: PropTypes.number,
  onListingChange: PropTypes.func.isRequired,
  onProjectChange: PropTypes.func.isRequired,
  onPropertyIdOverrideChange: PropTypes.func.isRequired,
};
